"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var PromptablePropInterface = {
  onConfirm: _react.PropTypes.func.isRequired,
  onReject: _react.PropTypes.func.isRequired
};
var _default = PromptablePropInterface;
exports.default = _default;
module.exports = exports.default;